export default (): IDraftState => ({
  drafts: []
});
